import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private userPermissions: string[] = [];

  private apiUrl = 'https://exam.alarkkan.app/api/api/call'; 

  constructor(private http: HttpClient, private router: Router) { }

  checkUserPermissions(email: string, accessToken: string, refreshToken: string): Observable<any> {
    const body = {
      procedureName: 'checkUserPermissions',
      params: {
        Email: email,
        AccessToken: accessToken,
        RefreshToken: refreshToken,
      },
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' }});
  }

  setUserPermissions(permissions: string[]) {
    this.userPermissions = permissions;
  }

  hasPermission(permission: string): boolean {
    return this.userPermissions.includes(permission);
  }

  getUserPermissions(): string[] {
    return this.userPermissions;
  }

  logout(): void {
    this.userPermissions = [];
    sessionStorage.clear();
    this.router.navigate(['/']);
  }
}
